import Vue from 'vue'
import Map from './Map'
import Child from './Child'
import SvgIcon from './SvgIcon'
import Question from './Question'

// Components that are registered globaly.
[
  Map,
  Child,
  SvgIcon,
  Question,
].forEach(Component => {
  Vue.component(Component.name, Component)
})



// WEBPACK FOOTER //
// ./src/components/index.js